import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import {Container, Col, Row} from 'react-bootstrap';
import {makeStyles} from '@material-ui/core/styles';
import {Button} from '@material-ui/core';
import PropTypes from 'prop-types';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';
import {ThemeProvider} from '@material-ui/core/styles';
import {createTheme} from '@material-ui/core/styles';
import {ProductList} from '../../components/Common/data/Products';
import {Link} from 'react-router-dom';
import {
  setSessionStorageItem,
  SELECTED_PRODUCT_FOR_ILLUSTRATION,
  SELECTED_PRODUCT_FOR_SUBMIT_A_CASE,
  SESSION_STORAGE_CASE_RETURN_PATH,
  SESSION_STORAGE_CREATE_CASE,
  getSessionStorageItem,
  SESSION_STORAGE_ACCOUNT_KEY
} from "../../sessionStorage";
import RequestSession from '../Common/RequestSession';
import './HeroImage.scss';

function HeroImage(props) {
  const history = useHistory();

  const useStyles = makeStyles((theme) => ({
    heroImage: {
      backgroundRepeat: 'no-repeat',
    },
    background: {
      backgroundColor: '#fff',
    },
  }));

  const classes = useStyles();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedLink] = useState('');
  const [selectedSessionKey] = useState('');
  const [selectedscheduleSessionKey] = useState('');
  let url = window.location.pathname.split('/');
  let productKey = url[url.length - 1];
  const selectedProduct = ProductList().filter((product) => product.key === productKey);
  const termProductKey = "term-insurance";
  const spwlProductKey = "single-premium-whole-life";
  const submitCasePath = "/Activity/NewCase";
  const [smallImage] = useState(productKey === 'traditional-long-term-care' || productKey === 'disability-insurance');
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const isEnableMSEnableDICreateCase = accountObj && accountObj.msEnableDICreateCase;
  const isEnableCreateCase = (productKey === 'ABLTC' || (productKey === 'disability-insurance' && isEnableMSEnableDICreateCase));

  const getQuoteLabel = () => {
    if ((productKey === 'ABLTC'))
      return 'REQUEST AN ILLUSTRATION';
    else if ((productKey === 'traditional-long-term-care'))
      return 'NEEDS ANALYSIS';
    else if (productKey === 'disability-insurance')
      return 'HELP ME DECIDE';
    else
      return 'GET A QUOTE';
  }

  const onQuoteButtonClick = (path, isNewCaseButton, sessionkey) => {
    if (sessionkey) {
      sessionStorage.removeItem(sessionkey);
    }
    if ((productKey === 'traditional-long-term-care' || (productKey === 'disability-insurance' && !isNewCaseButton))) {
      history.push('/InsuranceTools/NeedsAnalysis');
      return;
    }
    if (productKey === "ABLTC" && isNewCaseButton) {
      setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH, "/Products/Landing/ABLTC")
    } else if (productKey === "disability-insurance" && isNewCaseButton) {
      setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH, "/Products/Landing/disability-insurance")
    }
    if (path === submitCasePath) {
      const selectedSubmitCaseProduct = {
        submitCaseProductKey: selectedProduct[0].submitCaseProductKey
      }
      setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedSubmitCaseProduct);
    }
    if (path)
      history.push(path);
    // }
  }

  const onSessionStore = () => {
    if (productKey !== termProductKey && productKey !== spwlProductKey && selectedLink !== submitCasePath) {
      setSessionStorageItem(SELECTED_PRODUCT_FOR_ILLUSTRATION, selectedProduct[0]);
    } else if (selectedLink === submitCasePath) {
      setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedProduct[0])
    } else if (productKey === spwlProductKey) {
      setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedProduct[0]);
    }
    history.push(selectedLink);
  }

  return (
    <Row className={`landing-hero-image justify-content-center ${classes.background}`}>
      <div className={`${classes.heroImage} ${smallImage ? `small-background-image` : `background-image`}`}>
        <Container fluid className="hero-content">
          <Row className="d-flex align-items-center ml-3">
            <Col lg>
              <Row className="mb-3 mt-4">
                <Breadcrumb breadcrumbLinks={[{name: 'HOME', href: '/'}, {name: 'PRODUCTS', href: '/Products'}]}
                            currentPage={props.title.toUpperCase()}/>
              </Row>
              <Row>
                <div className="landingPageSubtitle pt-5 pb-2">{props.title}</div>
              </Row>
              <Row>
                <div className="landingPageTitle mb-2">{props.subtitle}</div>
              </Row>
            </Col>
            <Col lg="auto" className="hero-form">
              {props.form}
            </Col>
          </Row>
          <Row className="ml-3 mb-4">
            {selectedProduct &&
              <React.Fragment>
                <Button variant="contained" color='primary'
                  onClick={() => onQuoteButtonClick(selectedProduct[0].href, false, selectedProduct[0].sessionKey)}>{getQuoteLabel()}</Button>
                {
                  isEnableCreateCase && <Button variant="contained" color='primary' className={'ml-3'}
                    onClick={() => onQuoteButtonClick(submitCasePath, true, SESSION_STORAGE_CREATE_CASE)}>CREATE INSURANCE CASE</Button>
                }
                <RequestSession
                  show={show}
                  onHide={() => handleClose()}
                  sessionKey={selectedSessionKey}
                  scheduleSessionKey={selectedscheduleSessionKey}
                  href={selectedLink}
                  onSessionStore={() => onSessionStore()}
                  isSessionStore={true}
                />
              </React.Fragment>
            }
          </Row>
        </Container>
      </div>

    </Row>
  );
}

HeroImage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default React.memo(HeroImage);


// WEBPACK FOOTER //
// ./src/components/ProductLanding/HeroImage.js